import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import axios from 'axios';
import LmHeader from '../components/LmHeader.jsx';
import LmFooter from '../components/LmFooter.jsx';

const Enter = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email.trim() || !formData.password.trim()) {
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('https://limitverify.ru:5000/api/client/login', {
        email: formData.email,
        password: formData.password
      });

      console.log('Вход клиента успешен:', response.data);

      // Сохраняем токен и данные клиента в localStorage
      localStorage.setItem('clientToken', response.data.token);
      localStorage.setItem('clientData', JSON.stringify(response.data.client));

      // Проверяем что данные сохранились
      const savedToken = localStorage.getItem('clientToken');
      const savedClient = localStorage.getItem('clientData');

      if (savedToken && savedClient) {
        // Переходим на страницу клиента
        setTimeout(() => {
          navigate('/cabinet');
        }, 300);
      } else {
        console.error('Ошибка сохранения данных авторизации клиента');
      }

    } catch (error) {
      console.error('Ошибка входа клиента:', error);
      if (error.response?.data?.error) {
        alert(error.response.data.error);
      } else {
        alert('Ошибка при входе. Проверьте email и пароль.');
      }
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = formData.email.trim() && formData.password.trim();

  return (
    <div className="lm-page">
      <LmHeader actions={[{ label: 'Главный экран', onClick: () => navigate('/') }]} />

      <main className="lm-content lm-content--center">
        <div className="lm-auth">
          <div className="lm-auth__head">
            <h1 className="lm-auth__title">Вход в личный кабинет</h1>
          </div>

          <form onSubmit={handleSubmit} className="lm-auth__form">
            <div className="lm-field">
              <span className="lm-field__label">Введите email</span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="email@example.com"
                required
                className="lm-field__input"
              />
            </div>

            <div className="lm-field">
              <span className="lm-field__label">Введите пароль</span>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="••••••••"
                  required
                  className="lm-field__input"
                  style={{ paddingRight: 32 }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(prev => !prev)}
                  aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    color: 'var(--text-muted)',
                    cursor: 'pointer',
                    padding: 0,
                    fontSize: 18,
                    lineHeight: 1
                  }}
                >
                  {showPassword ? <EyeInvisibleOutlined /> : <EyeTwoTone twoToneColor="#7C9178" />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="lm-btn lm-btn--block"
              disabled={!isFormValid || loading}
              style={{ textTransform: 'uppercase' }}
            >
              {loading ? 'Вход...' : 'Войти'}
            </button>

            <button
              type="button"
              className="lm-link"
              onClick={() => navigate('/forgot-password?type=client')}
            >
              Забыли пароль?
            </button>
          </form>

          <div className="lm-auth__row" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
            <span className="lm-link">Нет аккаунта клиента?</span>
            <span className="lm-link lm-link--light">Обратитесь к администратору</span>
          </div>
        </div>
      </main>

      <LmFooter />
    </div>
  );
};

export default Enter;
